<template>

<div class="loading-screen">
  <div class="loading-screen__content">
    <div class="loading-screen__logo">
      <img alt="Loading" src="/images/logo-icon.png">
      <div class="loading-screen__logo__overlay"></div>
    </div>
    <div class="loading-screen__title">{{ title }}</div>
    <div class="loading-screen__details">
      {{ details }}
      <slot></slot>
    </div>
  </div>
</div>


</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Daten werden geladen'
    },
    details: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>

</style>